import BiTmplDetail_4 from './bi-tmpl-detail-4.vue';
export default BiTmplDetail_4;
